import { useSendoutsDrawerStack } from '../context';

import { buildSendoutsDrawerNavigator } from './helpers/buildSendoutsDrawerNavigator';
import { useSendoutsSubmitCoordinator } from './useSendoutsSubmitCoordinator';

export const useSendoutsDrawerHandlers = ({ jobOrder, onSubmitSuccess = () => {} }) => {
  const { stack, openDrawer, closeDrawer, clearStack } = useSendoutsDrawerStack();

  const {
    setSendoverActiveStatus,
    onPlacementCreated,
    onDrawerSaved,
    onDrawerClose,
    submittingKey
  } = useSendoutsSubmitCoordinator({
    onSubmitSuccess,
    closeDrawer,
    clearStack
  });

  const navigator = buildSendoutsDrawerNavigator({
    openDrawer,
    jobOrder,
    setSendoverActiveStatus,
    onPlacementCreated
  });

  return { stack, ...navigator, onDrawerSaved, onDrawerClose, submittingKey };
};
